module.exports = __webpack_public_path__ + "img/logosamara.822e5ff6.svg";